import { Archive, Edit3, Printer, ListOrdered } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const FONT = { fontFamily: "'Crimson Text', Georgia, serif" };
const WORSHIP_SLOTS = [
  'Devotion 1', 'Devotion 2', 'Opening', 'Greeting', 'Offering',
  'A Selection', 'B Selection', 'C Selection',
  'Rehearse 1', 'Rehearse 2', 'Rehearse 3', 'Rehearse 4',
];

export { WORSHIP_SLOTS };

export const SundayWorshipSection = ({ worshipSongs, onArchiveView, onArchiveThis, onPrintSetlist, onEdit, onSongClick }) => (
  <section className="py-12 bg-gradient-to-br from-yellow-50 to-blue-50">
    <div className="max-w-4xl mx-auto px-4">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-5xl font-bold text-blue-800"><ListOrdered className="inline h-8 w-8 text-yellow-500 mr-2" />Songs for Sunday Worship</h2>
        <div className="flex gap-2 flex-wrap">
          <Button onClick={onArchiveView} variant="outline" className="border-blue-300 text-blue-700" style={FONT} data-testid="archive-btn">
            <Archive className="h-4 w-4 mr-1" /> View Archive
          </Button>
          {worshipSongs.some(s => s) && (
            <>
              <Button onClick={onArchiveThis} variant="outline" className="border-green-400 text-green-700 hover:bg-green-50" style={FONT} data-testid="archive-this-btn">
                <Archive className="h-4 w-4 mr-1" /> Archive This List
              </Button>
              <Button onClick={onPrintSetlist} variant="outline" className="border-yellow-400 text-yellow-700 hover:bg-yellow-50" style={FONT} data-testid="print-setlist-btn">
                <Printer className="h-4 w-4 mr-1" /> Print Setlist
              </Button>
            </>
          )}
          <Button onClick={onEdit} variant="outline" className="border-blue-300 text-blue-700" style={FONT} data-testid="edit-worship-btn">
            <Edit3 className="h-4 w-4 mr-1" /> Edit
          </Button>
        </div>
      </div>
      {worshipSongs.every(s => !s) ? (
        <p className="text-blue-600 text-center py-8" style={FONT}>No songs selected for this Sunday yet.</p>
      ) : (
        <div className="space-y-2">
          {WORSHIP_SLOTS.map((label, i) => (
            <div key={label} className={`flex items-center gap-3 p-3 bg-white rounded-lg border border-blue-200 ${worshipSongs[i] ? 'hover:border-yellow-400 cursor-pointer' : 'opacity-50'} transition-colors`}
              onClick={() => worshipSongs[i] && onSongClick(worshipSongs[i])} data-testid={`worship-song-${i}`}>
              <span className="text-yellow-600 font-bold text-sm w-24 text-right flex-shrink-0" style={FONT}>{label}</span>
              {worshipSongs[i] ? (
                <>
                  <span className="text-blue-800 font-semibold" style={FONT}>{worshipSongs[i].title}</span>
                  {worshipSongs[i].song_key && <Badge variant="outline" className="border-yellow-400 text-yellow-700 ml-auto" style={FONT}>{worshipSongs[i].song_key}</Badge>}
                </>
              ) : (
                <span className="text-blue-300 italic" style={FONT}>—</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  </section>
);
